import { Fragment, JSX } from "react";
import { DropdownButton, Row } from "@/utils/bootstrap";
import OptinsDropdownTitle from "./option-dropdown-title/OptinsDropdownTitle";

interface Props {
  title: string;
  children: JSX.Element[];
  isMulti?: boolean;
  withBorder?: boolean;
}

const OptionsDropdown: React.FC<Props> = ({
  title,
  children,
  isMulti = false,
  withBorder = false,
}) => {
  return (
    <div className={`addon-dropdown w-100 ${withBorder ? "with-border" : ""}`}>
      <DropdownButton
        variant="outline"
        title={<OptinsDropdownTitle title={title} />}
        as="ul"
        className="m-0 p-0"
      >
        {children?.map((child, key) => (
          <Fragment key={key}>
            {isMulti ? <Row className="m-0">{child}</Row> : child}
          </Fragment>
        ))}
      </DropdownButton>
    </div>
  );
};

export default OptionsDropdown;
